export default __webpack_public_path__ + "static/media/3dglasses.d0574596.png";